import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from 'angular-ts-decorators';
import { normalizeUrl } from './utils/normalize-url';
import template from './breadcrumbs-dynamic.component.html';
import { FaqContextService, ProductContextService, VideoContextService } from 'src/Foundation/Design/app';
var BreadcrumbsComponent = (function () {
    function BreadcrumbsComponent(productContextService, faqContextService, videoContextService) {
        this.productContextService = productContextService;
        this.faqContextService = faqContextService;
        this.videoContextService = videoContextService;
        this.breadcrumbItems = [];
    }
    BreadcrumbsComponent.prototype.ngOnInit = function () {
        this.productContextService.subscribe()
            .then(null, null, this.onProductChange.bind(this));
        this.faqContextService.subscribe()
            .then(null, null, this.onFaqItemChange.bind(this));
        this.videoContextService.subscribe()
            .then(null, null, this.onVideoChange.bind(this));
        this.breadcrumbItems.push({
            title: this.rootTitle,
            url: normalizeUrl(this.rootUrl),
        });
    };
    BreadcrumbsComponent.prototype.onProductChange = function (product) {
        this.product = product;
        var breadcrumbItem = {
            title: this.product.productName,
            url: normalizeUrl(this.product.supportPageUrl + "#/#" + this.product.sku),
        };
        if (this.breadcrumbItems.length > 1) {
            this.breadcrumbItems.splice(1);
        }
        this.breadcrumbItems.push(breadcrumbItem);
        this.addContextItem();
    };
    BreadcrumbsComponent.prototype.onFaqItemChange = function (faqItem) {
        this.changeContextItem('faq', faqItem === null || faqItem === void 0 ? void 0 : faqItem.code);
    };
    BreadcrumbsComponent.prototype.onVideoChange = function (video) {
        this.changeContextItem('video', video === null || video === void 0 ? void 0 : video.code);
    };
    BreadcrumbsComponent.prototype.addContextItem = function () {
        if (!this.contextTitle || !this.contextUrl) {
            return;
        }
        this.breadcrumbItems.push({
            title: this.contextTitle,
            url: normalizeUrl(this.product.supportPageUrl + "/" + this.product.sku + "/" + this.contextUrl),
        });
    };
    BreadcrumbsComponent.prototype.changeContextItem = function (urlSuffix, contextItemCode) {
        if (!contextItemCode) {
            this.breadcrumbItems.splice(this.breadcrumbItems.length - 1);
        }
        else {
            var contextItem = this.breadcrumbItems[this.breadcrumbItems.length - 1];
            contextItem.url = normalizeUrl(this.product.supportPageUrl + "/" + this.product.sku + "/" + urlSuffix + "/" + contextItemCode);
        }
    };
    BreadcrumbsComponent.$inject = ['productContextService', 'faqContextService', 'videoContextService'];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], BreadcrumbsComponent.prototype, "rootTitle", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], BreadcrumbsComponent.prototype, "rootUrl", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], BreadcrumbsComponent.prototype, "contextTitle", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], BreadcrumbsComponent.prototype, "contextUrl", void 0);
    BreadcrumbsComponent = __decorate([
        Component({
            selector: 'breadcrumbs',
            template: template,
        }),
        __param(0, Inject('productContextService')),
        __param(1, Inject('faqContextService')),
        __param(2, Inject('videoContextService')),
        __metadata("design:paramtypes", [ProductContextService,
            FaqContextService,
            VideoContextService])
    ], BreadcrumbsComponent);
    return BreadcrumbsComponent;
}());
export { BreadcrumbsComponent };
